<template>
    <v-dialog v-model="show" max-width="900px">
      <v-card class="privacy-modal">
        <v-card-title class="modal-title">
          POLÍTICA DE PRIVACIDADE
          <v-btn icon @click="$emit('close')" class="close-button d-none d-md-flex">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="privacy-content" @scroll="onScroll">
            <br/>
          <div class="intro">
            <p><strong>Responsável:</strong> Matchcalendars</p>
            <p><strong>E-mail:</strong> suporte@matchcalendars.com</p>
          </div>
          <div class="index mt-5">
            <ol type="A">
              <li><a href="#introducao">Introdução</a></li>
              <li><a href="#dados">Dados Recolhidos</a></li>
              <li><a href="#finalidade">Finalidade da Recolha </a></li>
              <li><a href="#base">Base Legal para o Tratamento</a></li>
              <li><a href="#armazenamento">Armazenamento e Segurança</a></li>
              <li><a href="#direitos">Direitos do Utilizador</a></li>
              <li><a href="#cookies">Cookies</a></li>
              <li><a href="#politica">Alterações à Política</a></li>
              <li><a href="#contactos">Contactos</a></li>
            </ol>
          </div>
          <br/>
          <div id="introducao">
            <p><strong>A. Introdução</strong></p>
            <p>O <strong>matchcalendars.com</strong> respeita a sua privacidade e está comprometido em proteger os seus dados pessoais. Esta Política explica como recolhemos, utilizamos e protegemos as suas informações. 
                <br/>Ao utilizar o nosso site, aceita esta Política de Privacidade. </p>
          </div>
          <div id="dados">
            <p><strong>B. Dados Recolhidos</strong></p>
            <p>Podemos recolher os seguintes dados:</p>
            <ul>
                <li>Endereço de email (quando fornecido voluntariamente para registo ou notificações). </li>
                <li>Preferências de disponibilidade (cores verde, amarelo e vermelho indicadas no calendário).  </li>
                <li>Dados técnicos (como endereço IP, tipo de navegador e dispositivo, através de cookies).  </li>                
            </ul>
          </div>
          <br/>
          <div id="finalidade">
            <p><strong>C. Finalidade da Recolha</strong></p>
            <p>Usamos os seus dados para:</p>
            <ul>
                <li>Fornecer o serviço de sugestão de datas para eventos. </li>
                <li>Enviar notificações relacionadas com eventos (se aplicável). </li>
                <li>Melhorar a experiência do utilizador e otimizar o funcionamento do site. </li>
            </ul>
        <p>Não vendemos nem partilhamos os seus dados com terceiros para fins comerciais. </p>
          </div>
          <br/>
          <div id="base">
            <p><strong>D. Base Legal para o Tratamento</strong></p>
            <p>Tratamos os seus dados com base no seu consentimento (quando se regista ou interage com o site) e no interesse legítimo em melhorar o serviço. </p>
          </div>
          <br/>
          <div id="armazenamento">
            <p><strong>E. Armazenamento e Segurança</strong></p>
            <ul>
                <li>Os seus dados são armazenados de forma segura e apenas pelo tempo necessário para cumprir as finalidades indicadas. </li>
                <li>Implementamos medidas para proteger contra acessos não autorizados, mas nenhum sistema é totalmente seguro. </li>
            </ul>
          </div>
          <br/>
          <div id="direitos">
            <p><strong>F. Direitos do Utilizador</strong></p>
            <p>Tem o direito de: </p>
            <ul>
                <li>Aceder, corrigir ou eliminar os seus dados pessoais. </li>
                <li>Retirar o consentimento (quando aplicável). </li>
                <li>Apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD) se achar que os seus direitos não estão a ser respeitados. </li>
            </ul>
            <p>Para exercer estes direitos, contacta-nos através de: <strong>info@matchcalendars.com</strong> </p>
          </div>
          <br/>
          <div id="cookies">
            <p><strong>G. Cookies</strong></p>
            <p>Usamos cookies para melhorar a experiência do utilizador. Pode gerir as preferências de cookies no seu navegador. </p>
          </div>
          <div id="politica">
            <p><strong>H. Alterações à Política</strong></p>
            <p>Se considerar que os seus direitos foram violados, pode apresentar uma reclamação à autoridade competente...</p>
          </div>
          <div id="contactos">
            <p><strong>J. Contactos</strong></p>
            <p>Para qualquer questão sobre privacidade, entra em contacto através de: <strong>info@matchcalendars.com</strong></p>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex d-md-none justify-center pt-2 pb-4">
          <v-row>
            <v-col cols="12" align="center" justify="center">
              <v-btn color="error" @click="$emit('close')" block>
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  props: {
    show:{
        typeof: Boolean, default: true
    }
  },
  watch:{
    show:{
        immediate: true,
        handler(val){
            if(val == false)
                this.$emit('close')
        }
    }
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      document.querySelector('.privacy-content').classList.toggle('scrolled', scrollTop + clientHeight >= scrollHeight);
    }
  }
}
</script>

<style scoped>
.privacy-modal {
  border-radius: 10px;
  overflow-y: auto;
  max-height: 85vh;
}

.modal-title {
  background: linear-gradient(to right, #FAD2E1, #D8E2DC, #FAD2E1);
  color: black;
  font-size: 20px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  color: black;
}

.privacy-content {
  padding: 20px;
  overflow-y: auto;
  max-height: 70vh;
  
}

.privacy-content::-webkit-scrollbar {
  width: 10px;
}

.privacy-content::-webkit-scrollbar-track {
  border-radius: 5px;
}

.privacy-content::-webkit-scrollbar-thumb {
  border-radius: 5px;
}

.index ol {
  padding-left: 20px;
}

.index a {
  color: #6A1B9A;
  text-decoration: none;
}
</style>
